import React from 'react';
import AppRoutes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { DevUserProvider } from './contexts/DevUserContext';

function App() {
  return (
    <AuthProvider>
      <DevUserProvider>
        <AppRoutes />
      </DevUserProvider>
    </AuthProvider>
  );
}

export default App;
